import React, { useState } from "react";
import style from "./index.module.scss";
import Card from "../Card";
import Form, { useForm } from "rc-field-form";
import { BiPaperPlane } from "react-icons/bi";
import { Button, message, Modal, Spin } from "antd";
import EvaluateLayout from "../EvaluateLayout";
import CardMany from "../CardMany";
import Ioitem from "../Card/Components/Ioitem";
import TeacherItem from "../Card/Components/TeacherItem";
import lodash from "lodash-es";
import useRequestFn from "../../../../../../utils/useRequestFn";
import {
    evaluationStatus,
    saveTeacherAnswer,
    SubEvaItemDataProps,
    submitEvaluation,
    TeaEvlProps
} from "../../../../Service";
import { ResultMessage } from "../../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../../service/service";

interface EvaluateProps {
    data: TeaEvlProps;
    headerDom: React.ReactNode; //头部组件
    reloadData: () => void;
}
const { confirm } = Modal;

export default function EvaluateMain({
    data,
    headerDom,
    reloadData
}: EvaluateProps) {
    const [form] = useForm<any>();
    const [saveOneAction, { loading: saveLoading }] =
        useRequestFn(saveTeacherAnswer);
    const [submitAction, { loading: submitLoading }] =
        useRequestFn(submitEvaluation);

    const [map, setMap] = useState(new Map());

    async function onSave(
        answer: string,
        questionId: string,
        evaluationId?: string
    ) {
        try {
            if (answer.includes("dota_Best")) {
                map.set(`${evaluationId}${questionId}`, {
                    id: answer.split("dota_Best")[0],
                    text: answer.split("dota_Best")[1]
                });
            }
            await saveOneAction({
                answer,
                evaluationId: data?.evaluationId || evaluationId || "",
                questionId
            });
        } catch (e) {
            ResultMessage.error(errorMessage(e), { duration: 3000 });
        }
    }

    function onFinish(formData: any[]) {
        const arr: SubEvaItemDataProps[] = [];
        for (const formDataKey in formData) {
            const [evaluationId, id, type] = formDataKey?.split(",");
            if (type === "one") {
                arr.push({
                    evaluationId,
                    id,
                    value: formData[formDataKey]
                });
            }
            if (type === "many") {
                const item = lodash.find(data.topics, { id });
                let start = item?.stuAnsMap.get(evaluationId);
                const newText = map.get(`${evaluationId}${id}`);

                let value = lodash.cloneDeep(formData[formDataKey]);
                let text = formData[formDataKey];
                if (start?.id === value && start?.text) {
                    text = `${start?.id}dota_Best${start?.text}`;
                }
                if (newText?.text && newText?.id === value) {
                    text = `${newText.id}dota_Best${newText.text}`;
                }

                arr.push({
                    evaluationId,
                    id,
                    value: text
                });
            }
        }
        confirm({
            title: "确认提交评价？",
            content: "确认提交后不可修改评价内容",
            async onOk() {
                try {
                    await submitAction({
                        data: arr,
                        evaluationId:
                            data?.evaluationId ||
                            data?.evaluationList[0]?.id ||
                            ""
                    });
                    message.success("评价成功！");
                    await reloadData();
                } catch (e) {
                    ResultMessage.error(errorMessage(e), {
                        duration: 3000,
                        width: 400
                    });
                }
            },
            onCancel() {}
        });
    }

    return (
        <EvaluateLayout breadcrumb="课程评价">
            {headerDom}
            <div className={style.main}>
                <Spin
                    spinning={saveLoading || submitLoading}
                    style={{ width: "100%" }}>
                    <div className={style.right}>
                        <Form form={form} onFinish={onFinish}>
                            {data?.evaluationList &&
                                data?.topics.map(item => (
                                    <CardMany
                                        key={item.id}
                                        onSave={value => onSave(value, item.id)}
                                        item={item}>
                                        <div>
                                            {data?.evaluationList.map(
                                                teacherItem => {
                                                    return (
                                                        <Form.Field
                                                            name={`${teacherItem.id},${item.id},many`}
                                                            key={teacherItem.id}
                                                            initialValue={
                                                                item.stuAnsMap.get(
                                                                    teacherItem.id
                                                                )?.id
                                                            }>
                                                            {({
                                                                value,
                                                                onChange
                                                            }) => (
                                                                <TeacherItem
                                                                    data={
                                                                        teacherItem
                                                                    }>
                                                                    <>
                                                                        <Ioitem
                                                                            {...{
                                                                                value,
                                                                                onChange
                                                                            }}
                                                                            disabled={
                                                                                data?.status !==
                                                                                evaluationStatus.NotEvaluated
                                                                            }
                                                                            queTypeId={
                                                                                item.queTypeId
                                                                            }
                                                                            stuText={
                                                                                item.stuAnsMap.get(
                                                                                    teacherItem.id
                                                                                )
                                                                                    ?.text ||
                                                                                ""
                                                                            }
                                                                            onSave={(
                                                                                value: string
                                                                            ) => {
                                                                                onSave(
                                                                                    value.replaceAll(
                                                                                        teacherItem.id,
                                                                                        ""
                                                                                    ),
                                                                                    item.id,
                                                                                    teacherItem.id
                                                                                );
                                                                            }}
                                                                            options={
                                                                                item.options
                                                                            }
                                                                        />
                                                                    </>
                                                                </TeacherItem>
                                                            )}
                                                        </Form.Field>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </CardMany>
                                ))}
                            {!data?.evaluationList &&
                                data?.topics.map(item => (
                                    <Form.Field
                                        name={`${data?.evaluationId},${item.id},one`}
                                        key={item.id}
                                        initialValue={item.stuAns}>
                                        <Card
                                            disabled={
                                                data?.status !==
                                                evaluationStatus.NotEvaluated
                                            }
                                            onSave={value =>
                                                onSave(value, item.id)
                                            }
                                            item={item}
                                        />
                                    </Form.Field>
                                ))}
                            {data?.status !== evaluationStatus.Evaluated && (
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className={style.button}>
                                    <BiPaperPlane size={16} /> 提交
                                </Button>
                            )}
                        </Form>
                    </div>
                </Spin>
            </div>
        </EvaluateLayout>
    );
}
